import { useState } from "react";

import { Search } from "lucide-react";

import { Namespace, useT } from "@racoon/i18n";
import { IcChat } from "@racoon/icons";
import { Plus } from "lucide-react";
import { Button, Input } from "@racoon/ui";
import { useGetChatsQuery } from "~/shared/api/chat/chat.api";
import { Loader2 } from "lucide-react";

import { matchesSearch } from "@racoon/lib";
export const ChatList = ({
  onSelectChat,
  onCreateNewChat,
}: {
  onSelectChat: (chatId: string | null, chatTitle: string | null) => void;
  onCreateNewChat: (isCreating: boolean) => void;
}) => {
  const t = useT();
  const [searchValue, setSearchValue] = useState("");
  const { data: chats = [], isLoading } = useGetChatsQuery();

  return (
    <div className="w-full dark:bg-slate-950 space-y-2">
      <div className="flex gap-2 items-center justify-between mb-4">
        <div className="flex gap-2 items-center font-semibold">
          <IcChat width={24} height={24} className="text-brand-blue" />
          {t(Namespace.Chat, "chats")}
        </div>

        {/* New Chat Button */}
        <Button
          id="chat-list-add-chat-button"
          variant="opacityBlueWithOutline"
          className="!rounded-full !p-0 w-8 h-8 flex items-center justify-center"
          onClick={() => {
            onCreateNewChat(true);
            onSelectChat(null, null);
          }}
        >
          <Plus className="size-4" />
        </Button>
      </div>
      <div className="w-full relative">
        <Input
          type="search"
          placeholder={t(Namespace.Common, "search")}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className="pl-9 !rounded-lg w-full"
          size="md"
        />
        <Search className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      </div>

      <div className="overflow-y-auto flex flex-col divide-y divide-slate-200 -mx-[16px] lg:mx-0">
        {isLoading ? (
          <div className="flex justify-center gap-2 px-2">
            <Loader2 className="h-8 w-8 animate-spin text-brand-blue" />
          </div>
        ) : (
          (() => {
            const filteredChats = [...chats].filter((chat) =>
              matchesSearch(chat.title, searchValue),
            );

            return filteredChats.length === 0 ? (
              <div className="flex justify-center px-2 py-4 text-muted-foreground">
                {t(Namespace.Common, "noResults")}
              </div>
            ) : (
              filteredChats.map((chat) => (
                <div
                  key={chat.id}
                  className={`flex items-center justify-between py-2 px-4 cursor-pointer font-normal hover:bg-brand-blue hover:text-text-invert min-w-0`}
                  onClick={() => onSelectChat(chat.id, chat.title || `Chat ${chat.id}`)}
                  title={chat.title || `Chat ${chat.id}`}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {chat.title || `Chat ${chat.id}`}
                  </span>
                </div>
              ))
            );
          })()
        )}
      </div>
    </div>
  );
};
